<template>
  <Alert
    v-if="!hasIntegracaoPontoMais"
    dense
    color="warning"
    class="mt-4"
    :actionText="$t('action.seePlans')"
    :actionIcon="''"
    @action="sendToUpgradePlan"
  >
    {{ $t("signAutomation.alertMassMigrationPlan") }}
  </Alert>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MigrationAlertUpgradePlan",

  methods: {
    sendToUpgradePlan() {
      this.$router.push({ name: "BillingUpgradePlan" });
    },
  },
  computed: {
    ...mapGetters(["hasIntegracaoPontoMais"]),
  },
};
</script>
